var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.087 7.19289C14.3799 6.89999 14.3799 6.42512 14.087 6.13223C13.7941 5.83933 13.3192 5.83933 13.0263 6.13223L9.9996 9.15895L6.97304 6.13239C6.68014 5.83949 6.20527 5.83949 5.91238 6.13239C5.61948 6.42528 5.61948 6.90015 5.91238 7.19305L8.93894 10.2196L6.13204 13.0265C5.83914 13.3194 5.83914 13.7943 6.13204 14.0872C6.42493 14.3801 6.8998 14.3801 7.1927 14.0872L9.9996 11.2803L12.8067 14.0873C13.0996 14.3802 13.5744 14.3802 13.8673 14.0873C14.1602 13.7944 14.1602 13.3196 13.8673 13.0267L11.0603 10.2196L14.087 7.19289Z",
    fill: "#404B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.659333fa624ec1d1bc1939d97b285204.svg";
export { ForwardRef as ReactComponent };